<template>
  <div id="my-details-change" class="row reverse-mobile">
    <div class="col-12 col-md-3">
      <UserMenu></UserMenu>
    </div>
    <div class="col-12 col-md-9">
      <div class="row mb-4">
        <div class="d-flex flex-row align-items-center">
          <i class="material-icons material-icons-title mr-2">person</i>
          <h2 class="mt-2">Update Details</h2>
        </div>
      </div>
      <div class="row">
        <div class="card w-100">
          <div class="card-body">
            <div class="col-12">
              <div class="alert alert-danger" v-if="errorFound">
                <strong>Whoops!</strong> We had some trouble updating you details
              </div>
              <form @submit.prevent="requestDetailsUpdate">
                <div class="form-group">
                  <div id="auth-messages" class="auth-messages"></div>
                  <label for="inputFirstName">First Name</label>
                  <input
                    type="text"
                    class="form-control"
                    id="inputFirstName"
                    aria-describedby="inputFirstname"
                    v-bind:placeholder="user.first_name"
                  />
                  <label for="inputLastName">Last Name</label>
                  <input
                    type="text"
                    class="form-control"
                    id="inputLastName"
                    aria-describedby="inputLastName"
                    v-bind:placeholder="user.last_name"
                  />
                  <small
                    id="emailHelp"
                    class="form-text text-muted"
                  >We'll never share your details with anyone else.</small>
                </div>
                <button id="sendButton" type="submit" class="btn btn-primary">Update My Details</button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UserMenu from "../components/UserMenu";
import UserService from "../services/user.service";
import router from "../router";
import storage from "store";
export default {
  name: "MyDetailsChange",
  computed: {
    user() {
      return this.$store.getters.getUser;
    }
  },
  components: {
    UserMenu
  },

  data() {
    return {
      detailsSent: false,
      errorFound: false,
      loading: false
    };
  },

  methods: {
    requestDetailsUpdate: function() {
      const swalWithBootstrapButtons = vm.$swal.mixin({
        customClass: {
          confirmButton: "btn btn-success",
          cancelButton: "btn btn-danger"
        },
        buttonsStyling: false
      });
      let id = this.user.id;
      let firstName = document.getElementById("inputFirstName").value;
      let lastName = document.getElementById("inputLastName").value;
      let telephoneNumber = document.getElementById("inputTelephoneNumber")
        .value;

      UserService.requestDetailsUpdate(id, firstName, lastName, telephoneNumber)
        .then(() => {
          this.detailsSent = true;
          this.errorFound = false;
          swalWithBootstrapButtons.fire(
            "Updated!",
            "Your details have been updated.",
            "success"
          );
        })
        .catch(() => {
          this.errorFound = true;
          this.detailsSent = false;
        })
        .finally(() => {});
    }
  },

  beforeMount() {}
};
</script>

<style scoped>
.auth-messages {
  display: none;
}
.swal2-popup .swal2-icon.swal2-warning {
  color: #dc3545;
  border-color: #dc3545;
}

.swal2-popup .swal2-icon.swal2-question {
  color: #CB2E37;
  border-color: #CB2E37;
}

.swal2-icon.swal2-success {
  color: #28a745;
  border-color: #28a745;
}

.swal2-popup .swal2-title {
  color: #CB2E37;
  font-weight: 600;
}

.swal2-popup .swal2-content {
  color: #6c757d;
  margin-right: 10px;
  font-size: 1rem;
  font-style: italic;
}

.swal2-popup .swal2-confirm {
  margin-right: 5px;
}

.swal2-popup .swal2-cancel {
  margin-left: 5px;
}

.material-icons-title {
  font-size: 50px;
  color: #7d7d7d;
}
</style>
